import React from 'react';
import { Button } from '@mui/material';
import { LinearProgressWithLabel } from 'components/Common/Progressbar';
import { Link } from 'react-router-dom';

interface ICourseStatus {
  cur_course: any;
  user_status: any;
  cur_lesson: any;
  comingSoon: boolean;
  userHasBiteU: boolean;
}

const CourseStatus: React.FC<ICourseStatus> = (props: ICourseStatus) => {
  const { cur_course, user_status, cur_lesson, comingSoon, userHasBiteU } = props;

  return (
    <>
      {!userHasBiteU ? (
        <div className='bite-u-course-status-cont'>
          <h1>You need an assigned license to access this course</h1>
          <p>To continue, Visit Account &gt; Users &gt; to assign
          an available BITE Enterprise license to your user or contact your team admin</p>
        </div>
      ) : (
        <div className='bite-u-course-status-cont'>
          <div className='bite-u-course-status-vid'>
            <div className='bite-u-play-btn'>
              <Link to={{
                pathname: '/bite-u/course-training',
                state: {
                  cur_course: cur_course,
                  user_status: user_status,
                  cur_lesson: cur_lesson
                },
              }}
              style={{ display: 'inline-block', width: '100%' }}>
                <svg xmlns='http://www.w3.org/2000/svg' width='56' height='56' viewBox='0 0 56 56' fill='none'>
                  <g filter='url(#filter0_b_4005_66860)'>
                    <path fillRule='evenodd' clipRule='evenodd' d='M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM23.625 38.2705L39.375 29.4672C40.5417 28.8151 40.5417 27.1849 39.375 26.5328L23.625 17.7295C22.4583 17.0774 21 17.8925 21 19.1967V36.8033C21 38.1075 22.4583 38.9226 23.625 38.2705Z' fill='#202227' fillOpacity='0.6'/>
                  </g>
                  <defs>
                    <filter id='filter0_b_4005_66860' x='-16' y='-16' width='88' height='88' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                      <feFlood floodOpacity='0' result='BackgroundImageFix'/>
                      <feGaussianBlur in='BackgroundImageFix' stdDeviation='8'/>
                      <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_4005_66860'/>
                      <feBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_4005_66860' result='shape'/>
                    </filter>
                  </defs>
                </svg>
              </Link>
            </div>
          </div>
          <h2>Video {cur_lesson.lesson.number}</h2>
          <h1>{cur_lesson.lesson.name}</h1>
          <p>{cur_course.blurb}</p>
          <div className='bite-u-progress-bar'>
            <p>Progress</p>
            <LinearProgressWithLabel value={cur_lesson.currentPercent ? cur_lesson.currentPercent * 100 : 0} />
          </div>
          {comingSoon ? (
            <Button className='bite-u-lesson-btn'>Coming Soon!</Button>
          ) : (
            <Link to={{
              pathname: '/bite-u/course-training',
              state: {
                cur_course: cur_course,
                user_status: user_status,
                cur_lesson: cur_lesson
              },
            }}
            style={{ display: 'inline-block', width: '100%' }}>
              <Button className='bite-u-lesson-btn'>{cur_lesson.currentPercent === 0 ? 'Start Video' : cur_lesson.currentPercent === 1 ? 'Start Over' : 'Continue Video'}</Button>
            </Link>
          )}
        </div>
      )}
    </>

  );
};

export default CourseStatus;
